import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6934 4.20995C18.2678 4.59289 18.423 5.36898 18.0401 5.94339L11.6085 15.5907L12.8057 16.788L20.9599 4.55664C21.3429 3.98222 22.119 3.82701 22.6934 4.20995C23.2678 4.59289 23.423 5.36898 23.0401 5.94339L14.0401 19.4434C13.8323 19.755 13.4958 19.957 13.1232 19.9939C12.7505 20.0308 12.3809 19.8987 12.1161 19.6339L10.1943 17.7121L9.04006 19.4434C8.83233 19.755 8.49584 19.957 8.12317 19.9939C7.7505 20.0308 7.38092 19.8987 7.11612 19.6339L1.11612 13.6339C0.627961 13.1457 0.627961 12.3543 1.11612 11.8661C1.60427 11.378 2.39573 11.378 2.88388 11.8661L7.80572 16.788L8.39151 15.9093L6.11612 13.6339C5.62796 13.1457 5.62796 12.3543 6.11612 11.8661C6.60427 11.378 7.39573 11.378 7.88388 11.8661L9.80572 13.788L15.9599 4.55664C16.3429 3.98222 17.119 3.82701 17.6934 4.20995Z"
        fill={colorValue}
      />
    </svg>
  );
};
